import { Types } from 'mongoose';

import { TRANSACTION_TYPE, TYPE_ENTRY } from '@shared/constants';

import { IBaseEntity } from '../common';
import { IAdditionalRate } from '../invoices';

export enum REPORT_TYPE {
  IS_RR = 'is_RR',
  IS_BPR = 'is_BPR',
  IS_CLAIMS = 'is_Claims',
  IS_GWP = 'is_GWP',
  IS_IRC_SL = 'is_IRC_SL',
  IS_PAYMENTS = 'is_Payments',
  IS_CMR = 'is_CMR',
  IS_FULL_REPORT = 'if',
}
export interface Panel {
  title: string;
  hasHeader: boolean;
  useFormIrcSL: boolean;
  useFormClaims: boolean;
  useFormGWP: boolean;
  useFormPayments: boolean;
  useCommissions?: boolean;
  useFullReport: boolean;
}

export interface ConfigureIrSL extends IBaseEntity {
  popupData: FieldsPopup[];
}

export interface FieldsPopup {
  reportClass: string;
  systemClasses: (string | Types.ObjectId)[];
}

export interface IClaimsWidget {
  _id: Types.ObjectId;
  class: string;
  count: number;
}

export interface IGwpWidget {
  // _id: Types.ObjectId;
  month: string;
  premium: number;
}
export interface IGwpWidgetReport {
  month: string;
  local: number;
  fronting: number;
  total: number;
}

export interface ICommissionsWidget {
  insurer: string;
  count: number;
}

export interface IIRCSLAggregatorSingleData {
  reportClass: string;
  systemClassData: {
    _id: Types.ObjectId;
    isLife: 'true' | 'false';
  }[];
}

export interface IIRCSLAggregatorSingleProcessData {
  reportClass: string;
  systemClassData: Types.ObjectId[];
}

export interface IIRCSLData {
  insurer: string;
  // displayValue: null | number;
  values: (number | null)[];
  totalGWP: null | number;
  commissionReceived: number;
  commissionReceivable: null | number;
  commissionDue: null | number;
}

export interface IIRCSLAggregator {
  popupData: IIRCSLAggregatorSingleData[];
}

export interface IClaimsReport {
  intimationNumber: string;
  status: string;
  policyNumber: string;
  currencyCode: string;
  customer: string;
  claimId: string;
  batchNumber: string;
  slaDays: string | number;
  requestedDate: string;
  claimCategory: string;
  beneficiaryName: string;
  beneficiaryId: string;
  vehicleNumber: string;
  surveyorName: string;
  surveyDate: string;
  dateOfLoss: string;
  claimAmount: string | number;
  conversionRate: string | number;
  insurerIntimationNumber: string;
  brokerIntimationNumber: string;
  settledAmount: string | number;
  settlementConversionRate: string | number;
  settledDate: string;
  settlementRemarks: string;
  profitOrLoss: string | number;
  rejectedDate: string;
  rejectedRemarks: string;
  payeeName: string;
  acrAmount: string | number;
  lossCatSumInsured: string | number;
  deductibles: string | number;
  chRemarks: string;
  category: string;
  hodRemarks: string;
  remarks: string;
}

export interface IFullReport {
  adviceNo: string;
  insured: string;
  status: string;
  insurer: string;
  policyNo: string;
  type: string; // Frontend or Local
  policyClass: string;
  transaction: TRANSACTION_TYPE;
  trDate: string;
  creditDebit: TYPE_ENTRY;
  invoiceNumber: string;
  policyFrom: string;
  policyTo: string;
  currency: string;
  exRate: string;
  grossTotal: string;
  basic: string;
  srcc: string;
  tc: string;
  covers: IAdditionalRate[];
  charges: { key: string; value: string }[];
  grossPremium: string;
  settledAmount: string;
  balanceAmount: string;
  outstanding: 'Yes' | 'No';
  outstandingDays: number;
  vehicle: string;
  remarks: string;
  agent: string;
  handledBy: string;
  enteredBy: string;
  editedBy: string;
  makePaymentInBaseCurrency?: boolean;
}

export interface IClaimReport {
  adviceNo: string;
  additionalCovers: any[];
  transactionDate: string;
  insured: string;
  insurer: string;
  policyRef: string;
  creditDebitNoteRef: string;
  policyClass: string;
  netPremium: string;
  tcAmount: string;
  basicCoverPercentage: string;
  basicCoverAmount: string;
  srcPercentage: string;
  srcAmount: string;
  tcPercentage: string;
  currency: string;
  exchangeRate: string;
  totalLkrValue: string;
  commissionReceivedAmount: string;
  commissionReceivedMonth: string;
  commissionReceivedYear: string;
  enteredBy: string;
  receivableNetPremiumPercentage: string;
  receivableNetPremiumAmount: string;
  receivableSrcPercentage: string;
  receivableSrcAmount: string;
  receivableTcPercentage: string;
  receivableTcAmount: string;
  totalLkrAmount: string;
  remainingCommissionAmount: string;
  receivedMonth: string;
  receivedYear: string;
}
